import { render, staticRenderFns } from "./riskTestDc.vue?vue&type=template&id=7a9082ad&scoped=true"
import script from "./riskTestDc.vue?vue&type=script&lang=js"
export * from "./riskTestDc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9082ad",
  null
  
)

export default component.exports